<lottie-player
  autoplay
  loop
  src="../../../../assets/logo-anim.json"
></lottie-player>
